import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';

import i18n from '@/initI18n';

import useActivitiesImports, { ImportMethodPath } from '@/activities/importActivities/composables/useActivitiesImport';
import LoginCnh from '@/shared/components/LoginCnh.vue';
import MaxWidthContainer from '@/shared/components/MaxWidthContainer.vue';
import Button from '@/shared/components/buttons/Button.vue';
import ButtonLink from '@/shared/components/buttons/ButtonLink.vue';
import FormFieldRadioGroup from '@/shared/components/form/FormFieldRadioGroup.vue';
import FormRadio from '@/shared/components/form/FormRadio.vue';
import store from '@/store';

import imgLogoCns from '../../assets/logo--cnh_industiral-black.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportChooseMethod',
  setup(__props) {

const $t = i18n.translate;
const { state, goNext } = useActivitiesImports();

onMounted(() => {
  state.importNextEnabled = true;
});

/* -- METHODS -- */
function setImportMethodSource(importMethodPath: ImportMethodPath) {
  state.importMethodPath = importMethodPath;
  if (importMethodPath === 'load-data/cnh')
    store.commit('activities/importActivities/updateActivityImportMapDataRequestParameters', { source: 'CnhDownload' });
  if (importMethodPath === 'load-data/upload')
    store.commit('activities/importActivities/updateActivityImportMapDataRequestParameters', { source: 'UserUpload' });
  state.selectedUploadFile = '';
}

return { __sfc: true,$t, state, goNext, setImportMethodSource, LoginCnh, MaxWidthContainer, Button, ButtonLink, FormFieldRadioGroup, FormRadio, imgLogoCns }
}

})